import React from "react";
import { Login } from "./login";

interface Props {}

export function LoginRoute(props: Props) {
  return <Login />;
}
